import OrbitAvatar from '@/components/OrbitAvatar'
import { getOrganizationList } from '@/services/organization/organization.service'
import { DownOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Button, Card, Col, Divider, Dropdown, Menu, Row, Space, Typography } from 'antd'
import classnames from 'classnames'
import { memo, useMemo } from 'react'
import { Link, useParams } from 'react-router-dom'
import styles from './index.module.less'
const { Text } = Typography

export default memo(function OrgDashboard() {
  // const userInfo = useSelector(selectUser).userInfo!
  const { orgId } = useParams()
  const { data: organizationList = [] } = useRequest(getOrganizationList)
  const orgData = useMemo(() => organizationList.find((item) => item.id === Number(orgId)), [organizationList, orgId])

  return (
    <Row className={styles.container}>
      <Col flex={'350px'} className={classnames('p-3 border-right', styles.sidebar)}>
        <div>
          <Dropdown
            overlay={
              <Menu style={{ minWidth: '260px' }}>
                <Menu.ItemGroup title={'Switch Organization'}>
                  {organizationList.map((organization) => (
                    <Menu.Item key={organization.id}>
                      <Link to={`/orgs/${organization.id}/dashboard`}>{organization.name}</Link>
                    </Menu.Item>
                  ))}
                </Menu.ItemGroup>
              </Menu>
            }
            className={'ml-1'}
          >
            <Space>
              <OrbitAvatar avatar={orgData?.avatar!} name={orgData?.name} />
              <span>
                {orgData?.name} <DownOutlined />
              </span>
            </Space>
          </Dropdown>
        </div>

        <Divider />

        <div>
          <Button block>
            <Link to={`/${orgData?.id}/projects`} onClick={(event) => !orgData && event.preventDefault()}>
              View organization
            </Link>
          </Button>
          <Button block className='mt-2'>
            Browse organization's repositories
          </Button>
        </div>
      </Col>
      <Col flex={'auto'} className={classnames('p-3', styles.content)}>
        <Row>
          <Col span={18}>
            <div className={'mb-2'}>
              <Space className={'mb-1'}>
                <OrbitAvatar avatar={'#037C4B'} size={24} />
                <span>
                  <Text strong>Cindy</Text>
                  <span> comment to </span>
                  <Text strong>Cindy Organization / 2-way valve</Text>
                </span>
                <Text type={'secondary'}>8 hours ago</Text>
              </Space>

              <Card size={'small'}>
                <div>
                  <span>comment to </span>
                  <Text strong>Project Home page design </Text>
                </div>
                <div>
                  <Text type={'secondary'}>There are still a few renderings here</Text>
                </div>
              </Card>
            </div>

            <div className={'mb-2'}>
              <Space className={'mb-1'}>
                <OrbitAvatar avatar={'#037C4B'} size={24} />
                <span>
                  <Text strong>Cindy</Text>
                  <span> comment to </span>
                  <Text strong>Cindy Organization / 2-way valve</Text>
                </span>
                <Text type={'secondary'}>8 hours ago</Text>
              </Space>

              <Card size={'small'}>
                <div>
                  <span>comment to </span>
                  <Text strong>Project Home page design </Text>
                </div>
                <div>
                  <Text type={'secondary'}>There are still a few renderings here</Text>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  )
})
